import SummaryItem from './SummaryItem'
import restClient from 'Shared/hooks/restClient'
import { formatDate } from '../utils/dateAndMathsUtils'
import useCountTargets from 'Shared/hooks/useCountTargets'
import './SummaryItems.scoped.scss'
import Tooltip from "react-simple-tooltip"

const CAMPAIGN_LABELS = {
  whatsapp: {
    sms_blast: 'WhatsApp blast',
    sms_survey: 'WhatsApp survey',
    sms_conversations: 'WhatsApp conversations',
  },
  sms: {
    sms_blast: 'Text blast',
    sms_survey: 'Text survey',
    sms_conversations: 'Text conversations',
  },
}

const CampaignTypeSummaryItem = ({ campaignType, entityBlast }) => (
  <SummaryItem
    label="Campaign Type"
    value={campaignType !== 'email' ? CAMPAIGN_LABELS[entityBlast?.kind][campaignType] : 'Email blast'}
    icon={<SvgIconsSmsBlast />}
  />
)

const SubscriptionTopicSummaryItem = ({ subscriptionTopicLabel }) => (
  <SummaryItem
    label="Subscription Topic"
    value={subscriptionTopicLabel}
    icon={<SvgIconsQuote />}
  />
)

const SENDER_TYPE_LABELS = {
  phone_number: 'Phone number',
  rcs: 'RCS',
}

const SenderSummaryItem = ({ entityBlast, campaignType }) => {
  const senderType = campaignType === 'email'
    ? entityBlast?.emailSender : entityBlast?.senderType || 'phone_number'
  const senderName = campaignType === 'email'
    ? entityBlast?.emailSender.name : entityBlast?.senderName || SENDER_TYPE_LABELS[senderType] || 'Phone number'

  return (
    <SummaryItem
      label={(senderType === 'phone_number' || senderType === 'rcs') ? 'From' : 'Sender Name'}
      value={senderName}
      icon={<SvgIconsUser />}
    />
  )
}

function SummaryItems({ entityBlast, targetsCount }) {
  const isWorkflowControlled = useSel((s) => s.local.isWorkflowControlled)
  const { campaignType, subscriptionTopic } = useSel((s) => s.campaign || {})
  const campaignId = useSel((s) => s.local.campaignId)

  const {
    name: searchName,
    id: searchId,
  } = useSel((s) => s.campaign?.search || {})

  const provisionalTargetsCount = useCountTargets()

  const [workflows, setWorkflows] = useState([])
  useEffect(() => {
    restClient
      .get(`/api/campaigns/${campaignId}/workflows`)
      .then(({ data }) => setWorkflows(data))
  }, [])

  if (subscriptionTopic !== 'default') {
    const kind = campaignType === 'email' ? 'email' : entityBlast?.kind === 'whatsapp' ? 'whatsapp' : 'sms'
    var subscriptionTopicLabel = window.ENV.AVAILABLE_SUBSCRIPTIONS[kind].find(
      (sub) => sub.topic === subscriptionTopic
    )?.label
  }

  return (
    <div id="summary">
      <div className={`box ${isWorkflowControlled ? 'wider' : ''}`}>
        <SummaryItem
          label="Recipients"
          value={(targetsCount || provisionalTargetsCount.targetCount || 0).toLocaleString('en-US')}
          icon={<SvgIconsPersonBlue />}
          large
        />
      </div>
      {!isWorkflowControlled ? (
        <>
          <div className="box">
            <CampaignTypeSummaryItem
              campaignType={campaignType}
              entityBlast={entityBlast}
            />
            <SummaryItem
              label="Audience"
              link={searchId}
              value={searchName}
              icon={<SvgIconsAudience />}
              className="flex flex-wrap"
            >
              {(entityBlast?.isConstitutional ?? false) && <Tooltip content="This campaign includes those who are unsubscribed" className="tip-tooltip">
                <div className="tip">
                  <div className="icon">
                    <SvgIconsTip />
                  </div>
                  <p>Constitutional Send</p>
                </div>
              </Tooltip>}
            </SummaryItem>
            {subscriptionTopicLabel && (
              <SubscriptionTopicSummaryItem
                subscriptionTopicLabel={subscriptionTopicLabel}
              />
            )}
          </div>
          <div className="box">
            <SummaryItem
              label="Sent"
              value={
                entityBlast?.sentAt
                  ? formatDate(entityBlast?.sentAt)
                  : 'Now'
              }
              icon={<SvgIconsCalendar3 />}
            />
            <SenderSummaryItem
              campaignType={campaignType}
              entityBlast={entityBlast}
            />
          </div>
        </>
      ) : (
        <div className="box">
          <CampaignTypeSummaryItem
            campaignType={campaignType}
            entityBlast={entityBlast}
          />
          {subscriptionTopicLabel && (
            <SubscriptionTopicSummaryItem
              subscriptionTopicLabel={subscriptionTopicLabel}
            />
          )}
          <SenderSummaryItem
            campaignType={campaignType}
            entityBlast={entityBlast}
          />
          {workflows.length > 0 && (
            <>
              {workflows.map((workflow, i) => (
                <SummaryItem
                  key={i}
                  label="Automation"
                  value={workflow.name}
                  icon={<SvgIconsAutomations />}
                />
              ))}
            </>
          )}
        </div>
      )}
    </div>
  )
}

export default SummaryItems
